import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { AxiosError } from 'axios';

import { API_V3, ApiV3Response } from './types';

export const useAccount = (accountId: number) => {
  const enabled = !!accountId;
  return useQuery<Account, AxiosError>({
    queryKey: ['account', { accountId }],
    queryFn: () => getAccount(accountId ?? 0),
    enabled,
  });
};

export const getAccount = async (
  accountId: number,
  includeRelated: string[] = [],
): Promise<Account> => {
  const response = await axios.get<ApiV3Response<Account[]>>(`${API_V3}/accounts/`, {
    params: {
      include_related: JSON.stringify(includeRelated),
    },
  });
  const maybeAccount = response?.data?.data?.find(
    (account: Account) => account.id === accountId,
  ) || { id: null, name: 'No result', plan: 'N/A', discovery_api_url: 'N/A' };
  return maybeAccount;
};

export interface Account {
  id?: number | null;
  identifier?: string | null;
  name: string;
  plan: string;
  discovery_api_url: string;
}
